// Modern UI theme for Pattern Wars
const theme = {
  colors: {
    // Main colors
    primary: '#6C63FF',      // Vibrant purple
    secondary: '#4ECDC4',    // Teal
    accent: '#FF6B6B',       // Coral red
    
    // Backgrounds
    background: '#0F1624',   // Deep blue-black
    card: '#17223B',         // Slate blue
    overlay: 'rgba(15, 22, 36, 0.85)',
    
    // Text colors
    textPrimary: '#FFFFFF',
    textSecondary: '#A7B5CD',
    
    // Status colors
    success: '#6BCB77',
    warning: '#FFD166',
    error: '#F15BB5',
    
    // Player colors - Used in a gradient
    player1: '#6C63FF',
    player2: '#00F5FF',
    player3: '#00FFA3',
    player4: '#FFCC29'
  },
  
  // Typography
  typography: {
    fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    heading: {
      fontWeight: 700,
      lineHeight: 1.2,
    },
    body: {
      fontWeight: 400,
      lineHeight: 1.5,
    }
  },
  
  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  // Borders and shadows
  borders: {
    radius: {
      sm: '4px',
      md: '8px',
      lg: '16px',
      round: '50%',
    },
    shadow: {
      small: '0 2px 8px rgba(0, 0, 0, 0.15)',
      medium: '0 4px 12px rgba(0, 0, 0, 0.2)',
      large: '0 8px 24px rgba(0, 0, 0, 0.25)',
      glow: '0 0 16px rgba(108, 99, 255, 0.5)',
    },
  },
  
  // Animations
  animation: {
    durations: {
      fast: '150ms',
      normal: '300ms',
      slow: '500ms',
    },
    easing: {
      easeOut: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      easeInOut: 'cubic-bezier(0.65, 0, 0.35, 1)',
      bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    },
  },
  
  // Breakpoints for responsive design
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
  
  // Custom button styles
  buttons: {
    primary: {
      backgroundColor: '#6C63FF',
      color: '#FFFFFF',
      hoverBackgroundColor: '#5A52D5',
      activeBackgroundColor: '#4A43B0',
    },
    secondary: {
      backgroundColor: 'transparent',
      color: '#6C63FF',
      border: '2px solid #6C63FF',
      hoverBackgroundColor: 'rgba(108, 99, 255, 0.1)',
      activeBackgroundColor: 'rgba(108, 99, 255, 0.2)',
    },
    accent: {
      backgroundColor: '#FF6B6B',
      color: '#FFFFFF', 
      hoverBackgroundColor: '#FF5252',
      activeBackgroundColor: '#FF3838',
    },
  },
};

export default theme; 